var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94212 10.1538C2.50557 10.1538 2.96236 9.69698 2.96236 9.13352C2.96236 8.57007 2.50557 8.11328 1.94212 8.11328C1.37865 8.11328 0.921875 8.57007 0.921875 9.13352C0.921875 9.69698 1.37865 10.1538 1.94212 10.1538Z",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94212 3.01314C2.50557 3.01314 2.96236 2.55638 2.96236 1.9929C2.96236 1.42943 2.50557 0.972656 1.94212 0.972656C1.37865 0.972656 0.921875 1.42943 0.921875 1.9929C0.921875 2.55638 1.37865 3.01314 1.94212 3.01314Z",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94212 6.58345C2.50557 6.58345 2.96236 6.12669 2.96236 5.56321C2.96236 4.99973 2.50557 4.54297 1.94212 4.54297C1.37865 4.54297 0.921875 4.99973 0.921875 5.56321C0.921875 6.12669 1.37865 6.58345 1.94212 6.58345Z",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5625H10.6113",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.13672H10.6113",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.99219H10.6113",
    stroke: "white",
    strokeWidth: 1.02182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxns);
export default __webpack_public_path__ + "static/media/txns.480bda2b3f24dc4d35f92e1377e5639e.svg";
export { ForwardRef as ReactComponent };